export default "__VITE_ASSET__BIbFkANV__"